module.exports = __webpack_public_path__ + "static/img/fruit_bg.d7cc3b64.webp";